import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  Typography,
  RadioGroup,
} from "@material-ui/core";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { error } from "jquery";
import { FaCheckCircle } from "react-icons/fa";

export default function LoanColection({ title, link }) {
  const [file, setFile] = useState(null);
  const [selectLanguageDisplay, setSelectLanguageDisplay] = useState("en");
  const [answerload, setAnswerload] = useState(false);
  const [error, setError] = useState("");
  const [pdfdone, setPdfDone] = useState(false);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };
  const [uploadStatus, setUploadStatus] = useState(false);
  const [transcript, setTranScript] = useState("");
  const [displayText, setDisplayText] = useState("");
  const [summary, setSummary] = useState("");
  const [displaySummary, setDisplaySummary] = useState("");

  useEffect(() => {
    if (transcript.length > 0) {
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplayText((prev) => prev + transcript[index]);
        index++;
        if (index === transcript.length) {
          clearInterval(intevalId);
        }
      }, 25);
    }
  }, [transcript]);

  useEffect(() => {
    if (summary.length > 0) {
      let index = 0;
      const intevalId = setInterval(() => {
        setDisplaySummary((prev) => prev + summary[index]);
        index++;
        if (index === summary.length) {
          clearInterval(intevalId);
        }
      }, 25);
    }
  }, [summary]);

  const handleSubmit = async (event) => {
    setTranScript("");
    setSummary("");
    setDisplayText("");
    setDisplaySummary("");
    if (file && pdfdone) {
      setError("");
      event.preventDefault();
      setAnswerload(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("language", selectLanguageDisplay);
      try {
        const response = await axios.post(
          "https://zjrtewtlami4oic3hzimxzgrby0nhsaf.lambda-url.ap-south-1.on.aws/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        console.log(response);
        console.log(response.data);
        setTranScript(response.data[0]);
        setSummary(response.data[1]);
        setAnswerload(false);
      } catch (error) {
        console.error("Error uploading the file", error);
      }
    } else {
      setError("Please upload audio file");
    }
  };

  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  const handleUpload = () => {
    setError("Audio file uploaded successfully.");
    setUploadStatus(true);
    setPdfDone(true);
  };

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  return (
    <div>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {genaiaccess ? (
        <div
          style={{
            flex: "0.3",
            marginBottom: "1rem",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "80vw",
            gap: "3rem",
            margin: "auto",
          }}
          className="input-form-chatbot"
        >
          <div className="section-container">
            <h4>
              <strong>Audio File upload window</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            <div>
              {/* <input type="file" onChange={handleFileChange} accept="audio/*" /> */}
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  accept="audio/*"
                  id="audio-upload"
                  type="file"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <label htmlFor="audio-upload">
                  <Button
                    variant="contained"
                    component="span"
                    style={{ width: "130px", marginRight: "1rem" }}
                  >
                    Audio File
                  </Button>
                </label>

                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  disabled={!file}
                  onClick={handleUpload}
                >
                  Upload File
                </Button>
                {uploadStatus && (
                  <FaCheckCircle
                    style={{
                      marginLeft: "1rem",
                      color: "green",
                      top: "1rem",
                    }}
                    size={25}
                  />
                )}
              </div>
              <Typography variant="body1">
                <p style={{ wordBreak: "break-all", width: "350px" }}>
                  {file && `Selected file: ${file.name}`}
                </p>
              </Typography>

              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                startIcon={
                  answerload && <CircularProgress color="white" size={20} />
                }
              >
                Generate
              </Button>

              <br />
              {error}
              <br />
              <br />
              <h4>
                <strong>Select Language</strong>
              </h4>
              <hr style={{ background: "white" }}></hr>
              <FormControl>
                <RadioGroup
                  style={{ width: "18rem" }}
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={selectLanguageDisplay}
                  onChange={(e) => {
                    setSelectLanguageDisplay(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="en"
                    control={<Radio />}
                    label="English"
                  />
                  <FormControlLabel
                    value="hi"
                    control={<Radio />}
                    label="Hindi"
                  />
                  <FormControlLabel
                    value="mr"
                    control={<Radio />}
                    label="Marathi"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

          <div className="section-container">
            <h4>
              <strong>Generated Transcription</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            {displayText.length > 0
              ? displayText
              : "Transcription will be displayed here"}
          </div>
          <div className="section-container">
            <h4>
              <strong>Generated Summary</strong>
            </h4>
            <hr style={{ background: "white" }}></hr>
            {displaySummary.length > 0
              ? displaySummary
              : "Summary will be displayed here"}
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
